import {
  PencilSquareIcon,
  TrashIcon,
  InfoIcon,
  WarningIcon,
} from "components/Icons";

const icons = {
  edit: [PencilSquareIcon, "text-neutral-500 active:text-neutral-700"],
  open: [PencilSquareIcon, "text-neutral-500 active:text-cyan-700"],
  delete: [TrashIcon, "text-rose-400 active:text-rose-500"],
  info: [InfoIcon, "text-gray-700 active:text-gray-700"],
  warning: [WarningIcon, "text-amber-600 text-amber-800"],
};

export { icons };
